import { type FormEvent, useState } from 'react'
import { type RfqPayload, submitRfq } from '../lib/rates'

// Sponsorship-interest form for Chinese forwarders. Routes into the shared `freight_rfq` table
// (same as the English RFQ form) but tagged so the team can filter sponsorship leads: commodity
// carries the tag and notes packs WeChat / phone / lanes / tier that freight_rfq has no column for.
const input =
  'w-full rounded-md border border-border-strong bg-surface-0 px-3 py-2.5 text-sm text-ink placeholder:text-muted focus:border-signal focus:outline-none'

export function CnSponsorForm() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'done' | 'error'>('idle')

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setStatus('sending')
    const fd = new FormData(e.currentTarget)
    const wechat = str(fd, 'wechat')
    const phone = str(fd, 'phone')
    const lanes = str(fd, 'lanes')
    const tier = str(fd, 'tier')
    const msg = str(fd, 'message')
    const payload: RfqPayload = {
      name: str(fd, 'name'),
      email: str(fd, 'email'),
      company: str(fd, 'company'),
      commodity: '赞助合作 Sponsorship',
      notes: [
        '【赞助合作意向】',
        tier && `意向套餐：${tier}`,
        wechat && `微信：${wechat}`,
        phone && `电话：${phone}`,
        lanes && `主营航线：${lanes}`,
        msg && `留言：${msg}`,
      ]
        .filter(Boolean)
        .join('；'),
    }
    try {
      await submitRfq(payload)
      setStatus('done')
    } catch {
      setStatus('error')
    }
  }

  if (status === 'done') {
    return (
      <div className="rounded-lg border border-signal/40 bg-surface-0 p-6 text-center">
        <div className="font-display text-lg text-signal">已收到您的合作意向</div>
        <p className="mt-1 text-sm text-muted">
          我们会尽快通过微信或邮件与您联系，为您安排航线展位。
        </p>
      </div>
    )
  }

  return (
    <form onSubmit={onSubmit} className="grid gap-3 sm:grid-cols-2">
      <input className={input} name="company" required placeholder="公司名称 *" />
      <input className={input} name="name" placeholder="联系人" />
      <input className={input} name="wechat" placeholder="微信号" />
      <input className={input} name="email" type="email" required placeholder="业务邮箱 *" />
      <input className={input} name="phone" placeholder="手机 / 电话" />
      <input className={input} name="lanes" placeholder="主营航线（如 上海—英国、深圳—美西）" />
      <select className={`${input} sm:col-span-2`} name="tier" defaultValue="">
        <option value="" disabled>
          意向套餐（可选）
        </option>
        <option value="基础 入驻">基础 · 入驻（¥1,980/月）</option>
        <option value="高级 推荐">高级 · 推荐（¥4,980/月）</option>
        <option value="旗舰 独家">旗舰 · 独家（¥8,800/月）</option>
        <option value="先了解">先了解一下</option>
      </select>
      <textarea
        className={`${input} sm:col-span-2`}
        name="message"
        rows={3}
        placeholder="留言（服务航线、目的港、每月柜量等）…"
      />
      <button
        type="submit"
        disabled={status === 'sending'}
        className="sm:col-span-2 rounded-md bg-signal px-4 py-2.5 font-semibold text-on-accent hover:opacity-90 disabled:opacity-60"
      >
        {status === 'sending' ? '提交中…' : '提交合作意向'}
      </button>
      {status === 'error' && (
        <p className="sm:col-span-2 text-sm text-down">
          提交失败，请稍后重试，或直接加微信联系我们。
        </p>
      )}
      <p className="sm:col-span-2 text-xs text-muted">
        免费预约，无需承诺——我们会先与您确认航线与展位，再开始合作。
      </p>
    </form>
  )
}

function str(fd: FormData, k: string): string | undefined {
  const v = fd.get(k)
  return typeof v === 'string' && v.trim() ? v.trim() : undefined
}
